const MENUS = [
    {
        icon: 'el-icon-document',
        label: 'shareUserManagement',
        path: 'shareListUserChildren',
        meta: {
            permission: []
        },
        pathActive: ['shareListUserChildren', 'dataViewChildren', 'dataViewCreateChildren', 'dataViewDetailChildren', 'dataViewEditChildren', 'dataViewEditMultipleChildren'],
        subMenu: [
            {
                icon: '',
                label: 'dataViewChildren',
                path: 'dataViewChildren',
                meta: {
                    permission: []
                },
                pathActive: ['dataViewChildren'],
                subMenu: []
            },
            {
                icon: '',
                label: 'dataViewCreateChildren',
                path: 'dataViewCreateChildren',
                meta: {
                    permission: []
                },
                pathActive: ['dataViewCreateChildren'],
                subMenu: []
            },
            {
                icon: '',
                label: 'dataViewDetailChildren',
                path: 'dataViewDetailChildren',
                meta: {
                    permission: []
                },
                pathActive: ['dataViewDetailChildren'],
                subMenu: []
            },
            {
                icon: '',
                label: 'dataViewEditChildren',
                path: 'dataViewEditChildren',
                meta: {
                    permission: []
                },
                pathActive: ['dataViewEditChildren'],
                subMenu: []
            },
            {
                icon: '',
                label: 'dataViewEditMultipleChildren',
                path: 'dataViewEditMultipleChildren',
                meta: {
                    permission: []
                },
                pathActive: ['dataViewEditMultipleChildren'],
                subMenu: []
            }
        ]
    },
    {
        icon: 'el-icon-document',
        label: 'exportUserManagement',
        path: 'exportListUserChildren',
        meta: {
            permission: []
        },
        pathActive: ['exportListUserChildren'],
        subMenu: []
    },
    {
        icon: 'el-icon-document',
        label: 'shareManagement',
        path: 'dataLinkMultiList',
        pathActive: [
            'dataLinkMultiList',
            'editDataLinkMulti',
            'viewDataLinkMulti',
            'dataLinkMultiDataView',
            'dataLinkMultiDataViewCreate',
            'dataLinkMultiDataViewDetail',
            'dataLinkMultiDataViewEdit',
            'dataLinkMultiDataViewEditMultiple',
            'shareList',
            'addShare',
            'editShare',
            'dataView',
            'dataViewCreate',
            'dataViewDetail',
            'dataViewEdit',
            'dataViewEditMultiple'
        ],
        subMenu: [
            {
                icon: '',
                field: 'pageTaxProperty.field',
                label: 'dataLinkMultiList',
                path: 'dataLinkMultiList',
                meta: {
                    permission: []
                },
                pathActive: [
                    'dataLinkMultiList',
                    'editDataLinkMulti',
                    'viewDataLinkMulti',
                    'dataLinkMultiDataView',
                    'dataLinkMultiDataViewCreate',
                    'dataLinkMultiDataViewDetail',
                    'dataLinkMultiDataViewEdit',
                    'dataLinkMultiDataViewEditMultiple'
                ],
                subMenu: [
                    {
                        icon: '',
                        label: 'editDataLinkMulti',
                        path: 'editDataLinkMulti',
                        meta: {
                            permission: []
                        },
                        pathActive: ['editDataLinkMulti'],
                        subMenu: []
                    },
                    {
                        icon: '',
                        label: 'viewDataLinkMulti',
                        path: 'viewDataLinkMulti',
                        meta: {
                            permission: []
                        },
                        pathActive: ['viewDataLinkMulti'],
                        subMenu: []
                    },
                    {
                        icon: '',
                        label: 'dataLinkMultiDataView',
                        path: 'dataLinkMultiDataView',
                        meta: {
                            permission: []
                        },
                        pathActive: ['dataLinkMultiDataView'],
                        subMenu: []
                    },
                    {
                        icon: '',
                        label: 'dataLinkMultiDataViewCreate',
                        path: 'dataLinkMultiDataViewCreate',
                        meta: {
                            permission: []
                        },
                        pathActive: ['dataLinkMultiDataViewCreate'],
                        subMenu: []
                    },
                    {
                        icon: '',
                        label: 'dataLinkMultiDataViewDetail',
                        path: 'dataLinkMultiDataViewDetail',
                        meta: {
                            permission: []
                        },
                        pathActive: ['dataLinkMultiDataViewDetail'],
                        subMenu: []
                    },
                    {
                        icon: '',
                        label: 'dataLinkMultiDataViewEdit',
                        path: 'dataLinkMultiDataViewEdit',
                        meta: {
                            permission: []
                        },
                        pathActive: ['dataLinkMultiDataViewEdit'],
                        subMenu: []
                    },
                    {
                        icon: '',
                        label: 'dataLinkMultiDataViewEditMultiple',
                        path: 'dataLinkMultiDataViewEditMultiple',
                        meta: {
                            permission: []
                        },
                        pathActive: ['dataLinkMultiDataViewEditMultiple'],
                        subMenu: []
                    }
                ]
            },
            {
                icon: '',
                field: 'pageTaxProperty.field',
                label: 'shareList',
                path: 'shareList',
                meta: {
                    permission: []
                },
                pathActive: ['shareList', 'editShare', 'dataView', 'dataViewCreate', 'dataViewDetail', 'dataViewEdit', 'dataViewEditMultiple'],
                subMenu: [
                    {
                        icon: '',
                        label: 'editShare',
                        path: 'editShare',
                        meta: {
                            permission: []
                        },
                        pathActive: ['editShare'],
                        subMenu: []
                    },
                    {
                        icon: '',
                        label: 'dataView',
                        path: 'dataView',
                        meta: {
                            permission: []
                        },
                        pathActive: ['dataView'],
                        subMenu: []
                    },
                    {
                        icon: '',
                        label: 'dataViewCreate',
                        path: 'dataViewCreate',
                        meta: {
                            permission: []
                        },
                        pathActive: ['dataViewCreate'],
                        subMenu: []
                    },
                    {
                        icon: '',
                        label: 'dataViewDetail',
                        path: 'dataViewDetail',
                        meta: {
                            permission: []
                        },
                        pathActive: ['dataViewDetail'],
                        subMenu: []
                    },
                    {
                        icon: '',
                        label: 'dataViewEdit',
                        path: 'dataViewEdit',
                        meta: {
                            permission: []
                        },
                        pathActive: ['dataViewEdit'],
                        subMenu: []
                    },
                    {
                        icon: '',
                        label: 'dataViewEditMultiple',
                        path: 'dataViewEditMultiple',
                        meta: {
                            permission: []
                        },
                        pathActive: ['dataViewEditMultiple'],
                        subMenu: []
                    }
                ]
            },
            {
                icon: '',
                field: 'pageTaxProperty.field',
                label: 'addShare',
                path: 'addShare',
                meta: {
                    permission: []
                },
                pathActive: ['addShare'],
                subMenu: []
            }
        ]
    },
    {
        icon: 'el-icon-user',
        label: 'memberManagement',
        path: 'memberList',
        pathActive: ['memberList', 'editMember', 'addMember'],
        subMenu: [
            {
                icon: '',
                label: 'memberList',
                path: 'memberList',
                meta: {
                    permission: []
                },
                pathActive: ['memberList', 'editMember'],
                subMenu: [
                    {
                        icon: '',
                        label: 'memberEdit',
                        path: 'editMember',
                        meta: {
                            permission: []
                        },
                        pathActive: ['editMember'],
                        subMenu: []
                    }
                ]
            },
            {
                icon: '',
                label: 'memberAdd',
                path: 'addMember',
                meta: {
                    permission: []
                },
                pathActive: ['addMember'],
                subMenu: []
            }
        ]
    },
    {
        icon: 'el-icon-setting',
        label: 'settingKintone',
        path: 'settingKintone',
        meta: {
            permission: []
        },
        pathActive: ['settingKintone'],
        subMenu: []
    },
    {
        icon: 'el-icon-setting',
        label: 'setting',
        path: 'setting',
        meta: {
            permission: []
        },
        pathActive: ['setting'],
        subMenu: []
    },
    {
        icon: 'el-icon-s-promotion',
        label: 'mailInvite',
        path: 'mailInviteList',
        pathActive: ['mailInviteList', 'mailInviteAdd', 'mailInviteEdit'],
        subMenu: [
            {
                icon: '',
                label: 'mailInviteList',
                path: 'mailInviteList',
                meta: {
                    permission: []
                },
                pathActive: ['mailInviteList', 'mailInviteEdit'],
                subMenu: [
                    {
                        icon: '',
                        label: 'mailInviteEdit',
                        path: 'mailInviteEdit',
                        meta: {
                            permission: []
                        },
                        pathActive: ['mailInviteEdit'],
                        subMenu: []
                    }
                ]
            },
            {
                icon: '',
                label: 'mailInviteAdd',
                path: 'mailInviteAdd',
                meta: {
                    permission: []
                },
                pathActive: ['mailInviteAdd'],
                subMenu: []
            }
        ]
    },
    {
        icon: '',
        label: 'userInfo',
        path: 'userInfo',
        meta: {
            permission: []
        },
        pathActive: ['userInfo'],
        subMenu: []
    }
];
export { MENUS };
